<div class="row">
  <div class="col-12 ccm-card">
    <div class="left-img"><img src="../../assets/offline-img/ecrans_side_recharge.png"/></div>
    <h2 color="warm" class="col-6  mat-button mat-primary">
        Main Info
      </h2>
      <mat-card class="ccm-content-card col-12 box-shadow">
        <div class="row justify-content-end">
          <div class="col-10">
            
                <mat-card-content >
                    <h4 class="col-12  mat-button mat-primary"> Color main text </h4>
                    <div class="col-12 row">
                      <div class="col-sm-4">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, sit amet erat. Duis semper. 
                        </p>
                      </div>
                      <div class="col-sm-4">
                          <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, sit amet erat. Duis semper. 
                          </p>
                        </div>
  
                    </div>
                    <h3 class="col-12  mat-button mat-primary">Content color title</h3>
                    <h4 class="col-12"> Main text</h4>
                    <div class="col-12 row">
                        <div class="col-3">
                            <div class="row icon-detail" >
                                <div class="col-12">
                                    <div class="icon-bg">
                                        <mat-icon style="height:100%; width:100%;" svgIcon="recharge"></mat-icon>
                                    </div>
                                </div>
                                <p class="col-12">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                  </p>
                              </div>
                        </div>
                        <div class="col-3">
                            <div class="row icon-detail" >
                                <div class="col-12">
                                    <div class="icon-bg">
                                        <mat-icon style="height:100%; width:100%;" svgIcon="recharge"></mat-icon>
                                    </div>
                                </div>
                                <p class="col-12">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                  </p>
                              </div>
                        </div>
                        <div class="col-3">
                            <div class="row icon-detail" >
                                <div class="col-12">
                                    <div class="icon-bg">
                                        <mat-icon style="height:100%; width:100%;" svgIcon="recharge"></mat-icon>
                                    </div>
                                </div>
                                <p class="col-12">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                  </p>
                              </div>
                        </div>
                        <div class="col-3">
                            <div class="row icon-detail" >
                                <div class="col-12">
                                    <div class="icon-bg">
                                        <mat-icon style="height:100%; width:100%;" svgIcon="recharge"></mat-icon>
                                    </div>
                                </div>
                                <p class="col-12">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                  </p>
                              </div>
                        </div>
                      </div>
                      <h4 class="col-12"> Main text</h4>
                      <div class="row">
                          <div class="col-3">
                              <div class="row icon-detail" >
                                  <div class="col-12">
                                      <div class="icon-bg">
                                          <mat-icon style="height:100%; width:100%;" svgIcon="recharge"></mat-icon>
                                      </div>
                                  </div>
                                  <p class="col-12">
                                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                          </div>
                        </div>
                </mat-card-content>
          </div>
        </div>

    
         
        </mat-card>
  </div>
</div>